import React, { useEffect, useState } from 'react';
import codes from '../../../utils/constants/codes';
// @ts-ignore
import unavailableErrors from './unvailabeWebAppPage.module.scss';
import PhoneNoFillIcon from '../../icons/phoneNoFillIcon';
import EmailIcon from '../../icons/emailIcon';
import CopyPasteIcon from '../../icons/copyPasteIcon';
import CheckedIcon from '../../icons/checkedIcon';
import { store } from '../../../store/store';

const UnavailableWebAppPage = props => {
    const { errorImage } = props;
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        setTimeout(() => setCopied(false), 3000);
    }, [copied]);

    const copy = item => {
        const el = document.createElement('input');
        el.value = item;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        setCopied(true);
    };
    const currentCountryCode = store
        .getState()
        .applicationSettings.apiApplicationSettings?.currentCountryCode.toUpperCase();
    return (
        <div className={unavailableErrors['wrapper']}>
            <div className={unavailableErrors['image']}>
                <img alt={'wrencher'} src={errorImage.error} />
            </div>
            <div className={`${unavailableErrors['content']}`}>
                <div className={`${unavailableErrors['logoText']}`}>
                    <img
                        className={`${unavailableErrors['logo']}`}
                        src={errorImage.logo}
                        alt="ARAG Logo"
                    />
                    <div className={unavailableErrors['text']}>
                        <p className={unavailableErrors['par']}>
                            {codes.unavailableBlankPage}
                        </p>
                    </div>
                    <div className={unavailableErrors['secondary-text']}>
                        <p className={unavailableErrors['par']}>
                            {codes.unavailableContantIT}
                        </p>
                    </div>
                    <div className={'row'}>
                        <div
                            className={`${unavailableErrors['email']} col-sm-1 `}
                        >
                            <PhoneNoFillIcon
                                className={unavailableErrors['mainIcon']}
                            />
                        </div>
                        <div
                            className={`${unavailableErrors['phone']} col-sm-10`}
                        >
                            <p className={unavailableErrors['emailText']}>
                                {' '}
                                {codes[
                                    `emailContactNumber${currentCountryCode}`
                                ] || 'Unknown'}
                            </p>
                        </div>
                    </div>
                    <div className={'row'}>
                        <div
                            className={`${unavailableErrors['email']} col-sm-1 `}
                        >
                            <EmailIcon
                                className={unavailableErrors['mainIcon']}
                            />
                        </div>
                        <div
                            className={`${unavailableErrors['link']} col-sm-10`}
                        >
                            <div className={unavailableErrors['tooltip']}>
                                <button
                                    onClick={() =>
                                        copy(
                                            codes[
                                                `emailContactEmail${currentCountryCode}`
                                            ] || 'Unknown',
                                        )
                                    }
                                    className={unavailableErrors['btn']}
                                    id={'unavailable-button'}
                                >
                                    <span
                                        className={
                                            unavailableErrors['tooltipText']
                                        }
                                        id={'tooltipText'}
                                    >
                                        {codes.copyToClipboard}
                                    </span>
                                    {codes[
                                        `emailContactEmail${currentCountryCode}`
                                    ] || 'Unknown'}
                                    {!copied ? (
                                        <CopyPasteIcon
                                            className={
                                                unavailableErrors['icon']
                                            }
                                            id={'copyPaste'}
                                        />
                                    ) : (
                                        <CheckedIcon
                                            className={
                                                unavailableErrors['icon']
                                            }
                                            id={'checked'}
                                        />
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UnavailableWebAppPage;
